import baseGet from "./component-library329.mjs";
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}
export {
  basePropertyDeep as default
};
